/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { HideOutlined } from "@duxton-web/icons"
import React from "react"
import { isEmpty } from "lodash"
import { TAttributeDrawerReviewData } from "./AttributeDrawerReview/AttributeDrawerReview.model"
import styles from "./AttributeDrawer.modules.css"

const excludedInShow = [
  "categoryID",
  "itemName",
  "priceInMin",
  "itemClassID",
  "alcoholTagging",
  "tobaccoTagging",
  "attributeForm",
]

export const removeEmptyData = (data: TAttributeDrawerReviewData[]) => {
  return data.filter(v => v.value !== "" && !excludedInShow.includes(v.label))
}
export const transformFormData = (
  formData: Record<string, string | string[] | any | undefined>,
): TAttributeDrawerReviewData[] => {
  return Object.keys(formData).map(v => {
    let value
    if (Array.isArray(formData[v]) && (formData[v] as string[]).length > 0) {
      value = (formData[v] as string[]).join(", ")
    } else if (typeof formData[v] === "string" && formData[v] !== "") {
      value = formData[v] as string
    } else if (
      typeof formData[v] === "object" &&
      !isEmpty(formData[v]?.value) &&
      !isEmpty(formData[v]?.unitLocalization)
    ) {
      value = `${formData[v]?.value} ${formData[v]?.unitLocalization}`
    } else {
      value = ""
    }

    return {
      label: v,
      value,
    }
  })
}

export const notShowToPax = (text: string) => {
  return (
    <span className={styles.brownText}>
      <HideOutlined /> {text}
    </span>
  )
}
